














































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import InfoIcon from '@/components/icons/Info.vue';
import AnalyticsArrowUp from '@/components/icons/AnalyticsArrowUp.vue';
import AnalyticsArrowDown from '@/components/icons/AnalyticsArrowDown.vue';
import AnalyticsArrowRight from '@/components/icons/AnalyticsArrowRight.vue';

import { abbreviateNumber } from '@/utils/currency';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import Arrow from '@/components/icons/Arrow.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Loading from '@/components/icons/Loading.vue';
import { EBusinessReportType } from '@/models/business';

import segmentIo from '@/utils/segment.io';

export enum EAnalyticsCardArrowDirection {
  UP = 'up',
  DOWN = 'down',
  RIGHT = 'right'
}

export type AnalyticsCardvariant = 'default' | 'white';

export type AnalyticsCardInsightVariant =
  | 'success'
  | 'danger'
  | 'default'
  | 'normal'
  | 'regular';

export type AnalyticsCardProps = {
  title?: string;
  largeTitle?: string;
  auxiliarTitle?: string;
  amount?: string | number;
  prefixAmount?: string;
  sufixAmount?: string;
  description?: string;
  insightText?: string;
  tooltipText?: string;
  tooltipIconPlacement?: 'after-title' | 'right-corner';
  arrowDirection?: EAnalyticsCardArrowDirection;
  counterFractionDigits?: number;
  disableAbbreviateAmount?: boolean;
  insightVariant?: AnalyticsCardInsightVariant;
  linkClickTrackEvent?: string;
  linkLabel?: string;
  link?: string;
  reportType?: EBusinessReportType[];
};

@Component({
  components: {
    InfoIcon,
    AnalyticsArrowUp,
    AnalyticsArrowDown,
    AnalyticsArrowRight,
    GhostButton,
    Arrow,
    Typography,
    Loading
  }
})
export default class AnalyticsCard extends Vue {
  @Prop({ default: 'default' }) variant!: AnalyticsCardvariant;
  @Prop({ default: 'default' }) insightVariant!: AnalyticsCardInsightVariant;
  @Prop() showLoader?: boolean;
  @Prop({ default: 0 }) minWidthCardMobile!: number;
  @Prop({ required: true, default: () => ({}) }) infos!: AnalyticsCardProps;

  dataTippyNumber = Math.floor(Math.random() * 100000);

  get arrow() {
    switch (this.infos.arrowDirection) {
      case EAnalyticsCardArrowDirection.UP:
        return 'AnalyticsArrowUp';

      case EAnalyticsCardArrowDirection.DOWN:
        return 'AnalyticsArrowDown';

      case EAnalyticsCardArrowDirection.RIGHT:
        return 'AnalyticsArrowRight';

      default:
        return '';
    }
  }

  get counter() {
    if (this.infos.disableAbbreviateAmount) return this.infos.amount;

    return abbreviateNumber(
      Number(this.infos.amount) || 0,
      this.infos.counterFractionDigits
    );
  }

  goTo() {
    if (this.infos.link) {
      if (this.infos.linkClickTrackEvent)
        segmentIo.track(this.infos.linkClickTrackEvent);
      this.$emit('goTo', this.infos.link);
      this.$router.push(this.infos.link);
    }
  }
}
